import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { setupScrollAnimations } from '../utils/scrollAnimations';
import './style.css';
import MarbleProject1 from './images/marble/MarbleProject1.png';
import MarbleFirst from './images/marble/Marblefirst.png';
import DownloadImage from './images/marble/download.jpeg';
import PremiumMarbleSourcing from './images/marble/Premium marble sourcing.jpg';
import MarbleInstallation from './images/marble/Marble Installation.jpg';
import MarbleRestoration from './images/marble/Marble Res.png';

const Marble = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    setupScrollAnimations();
  }, []);
  
  return (
    <motion.main
      className="page-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
        <div className="service-content">
          {/* Hero Section with Image */}
          <div className="service-hero animate-on-scroll">
            <div className="service-hero-content">
              <h1>{t('services.marble.title')}</h1>
              <p className="service-hero-subtitle">
                {t('services.marble.subtitle')}
              </p>
            </div>
            <div className="service-hero-image">
              <img src={MarbleFirst} alt="Marble Quarry and Services" className="hero-image" />
            </div>
          </div>
          
          {/* Services Grid with Images */}
          <div className="service-sections">
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">💎</div>
                <h3>{t('services.marble.sourcing.title')}</h3>
                <p>
                  {t('services.marble.sourcing.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={PremiumMarbleSourcing} alt="Premium Marble Sourcing" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">✂️</div>
                <h3>{t('services.marble.cutting.title')}</h3>
                <p>
                  {t('services.marble.cutting.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={DownloadImage} alt="Marble Fabrication Process" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🏠</div>
                <h3>{t('services.marble.installation.title')}</h3>
                <p>
                  {t('services.marble.installation.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={MarbleInstallation} alt="Marble Installation" className="service-image" />
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">✨</div>
                <h3>{t('services.marble.restoration.title')}</h3>
                <p>
                  {t('services.marble.restoration.description')}
                </p>
              </div>
              <div className="service-section-image">
                <img src={MarbleRestoration} alt="Marble Restoration & Maintenance" className="service-image" />
              </div>
            </div>
          </div>
          
          {/* Features Section */}
          <div className="service-features">
            <h3>{t('services.marble.applications.title')}</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🍽️</div>
                <div className="feature-text">{t('services.marble.applications.item1')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛁</div>
                <div className="feature-text">{t('services.marble.applications.item2')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏠</div>
                <div className="feature-text">{t('services.marble.applications.item3')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🪜</div>
                <div className="feature-text">{t('services.marble.applications.item4')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔥</div>
                <div className="feature-text">{t('services.marble.applications.item5')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏢</div>
                <div className="feature-text">{t('services.marble.applications.item6')}</div>
              </div>
            </div>
          </div>
          
          {/* Gallery Section */}
          <div className="service-gallery">
            <h3>{t('services.marble.gallery.title')}</h3>
            <div className="gallery-grid">
              <div className="gallery-item clickable-gallery-item" onClick={() => window.location.href = '/projects?filter=marble'}>
                <img src={MarbleProject1} alt="Marble Project 1" className="gallery-image" />
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 2</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 3</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 4</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Us Section */}
          <div className="service-contact-section">
            <div className="service-contact-content">
              <h3>{t('services.marble.contact.title')}</h3>
              <p>{t('services.marble.contact.description')}</p>
              <Link to="/contact?service=marble" className="service-contact-btn btn-animated hover-lift">
                {t('services.marble.contact.button')}
              </Link>
            </div>
          </div>
      </div>
    </motion.main>
  );
};

export default Marble;
